import { render, staticRenderFns } from "./FooterTabbar.vue?vue&type=template&id=e48c4cee&"
import script from "./FooterTabbar.vue?vue&type=script&lang=js&"
export * from "./FooterTabbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e48c4cee')) {
      api.createRecord('e48c4cee', component.options)
    } else {
      api.reload('e48c4cee', component.options)
    }
    module.hot.accept("./FooterTabbar.vue?vue&type=template&id=e48c4cee&", function () {
      api.rerender('e48c4cee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FooterTabbar.vue"
export default component.exports